(function () {
  var AudioContextClass = window.AudioContext || window.webkitAudioContext;
  var context;
  var oscillator;
  var harmonicOscillator;
  var gain;
  var muted = false;
  var activated = false;
  try {
    muted = window.sessionStorage.getItem('barbasAmbientMuted') === '1';
    activated = window.sessionStorage.getItem('barbasAmbientActivated') === '1';
  } catch (error) { /* Storage may be unavailable in a private browser. */ }

  function save(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) { /* Keep sound working without storage. */ }
  }

  function start() {
    if (muted || !AudioContextClass) return;
    try {
      context = context || new AudioContextClass();
      if (context.state === 'suspended') context.resume().catch(function () {});
      if (oscillator) return;
      oscillator = context.createOscillator();
      harmonicOscillator = context.createOscillator();
      gain = context.createGain();
      var harmonicGain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = 116;
      harmonicOscillator.type = 'sine';
      harmonicOscillator.frequency.value = 232;
      harmonicGain.gain.value = .28;
      gain.gain.setValueAtTime(0, context.currentTime);
      gain.gain.linearRampToValueAtTime(.028, context.currentTime + 2);
      oscillator.connect(gain).connect(context.destination);
      harmonicOscillator.connect(harmonicGain).connect(gain);
      oscillator.start();
      harmonicOscillator.start();
      activated = true;
      save('barbasAmbientActivated', '1');
    } catch (error) { /* The page remains usable if audio is blocked. */ }
  }

  function stop() {
    if (!oscillator || !context) return;
    gain.gain.cancelScheduledValues(context.currentTime);
    gain.gain.setTargetAtTime(.0001, context.currentTime, .08);
    oscillator.stop(context.currentTime + .4);
    harmonicOscillator.stop(context.currentTime + .4);
    oscillator = null;
    harmonicOscillator = null;
    gain = null;
  }

  function setMuted(value) {
    muted = Boolean(value);
    save('barbasAmbientMuted', muted ? '1' : '0');
    if (muted) stop();
    else start();
    document.dispatchEvent(new Event('barbas:ambient-change'));
  }

  window.BarbasAmbient = { start: start, setMuted: setMuted, isMuted: function () { return muted; } };
  document.addEventListener('pointerdown', start, { passive: true });
  document.addEventListener('keydown', start);

  function ready() {
    if (activated) start();
    if (document.getElementById('barbas-access')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'BarbasAmbient__toggle';
    button.setAttribute('aria-label', 'Toggle ambient sound');
    function update() {
      button.textContent = muted ? 'SOUND OFF' : 'SOUND ON';
      button.setAttribute('aria-pressed', String(!muted));
    }
    button.addEventListener('click', function () { setMuted(!muted); });
    document.addEventListener('barbas:ambient-change', update);
    update();
    document.body.appendChild(button);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
}());
